import { SelectOption } from "../../common/types"
import HttpClient from "../helpers/HttpClient"
import Label, { LabelDto } from "./Label"


class LabelService {
    static httpClient = new HttpClient<Label, LabelDto>(Label)

    static async getLabelsOf(type?: string) {
        const res = await this.httpClient.get("/labels")
        if (Array.isArray(res) && type) {
            return res.filter(l => (l as Label).getType() == type)
        }

        return res
    }

    static async getLabelsAsSelectOptions(type?: string): Promise<SelectOption<string>[]> {
        const res = await this.getLabelsOf(type)

        if (Array.isArray(res)) {
            return res.map(label => ({
                value: label.getId(),
                label: label.getTitle(),
            }))
        }

        return []
    }
}

export default LabelService


// WEBPACK FOOTER //
// ./src/state/label/LabelService.ts